
<section class="flex justify-content-center mt-4">
    <div class="card-table col-12">
        <div >
            <CustomTitle [title]="'msg.panelDeTrámites' | translate"
                         styleClass="font-principal app-title-page-color font-medium font-23 mt-4  text-uppercase mb-0"/>
        </div>
        <p-tabView [(activeIndex)]="activeTabIndex" (activeIndexChange)="activeIndexChange($event)" class="w-full">
            <p-tabPanel [header]="'components.app-admin-tramites.tipos-de-tramite' | translate">
                <app-admin-tipo-tramite></app-admin-tipo-tramite>
            </p-tabPanel>
            <p-tabPanel [header]="'components.app-admin-tramites.categorizacion' | translate">
                <app-admin-categorizaciones></app-admin-categorizaciones>
            </p-tabPanel>
            <p-tabPanel [header]="'components.app-admin-tramites.actividades' | translate">
                <app-admin-actividades></app-admin-actividades>
            </p-tabPanel>
            <p-tabPanel [header]="'components.app-admin-tramites.dependencias' | translate">
                <app-admin-dependencia-tramite></app-admin-dependencia-tramite>
            </p-tabPanel>
            <p-tabPanel [header]="'common.reporteLogos' | translate">
                <app-reporte-logos></app-reporte-logos>
            </p-tabPanel>
        </p-tabView>
    </div>
</section>


